import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureBoundary } from '@ui/features';
import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { SparkleIconWhite } from '@ui/general';
import { useAnalysisPeriscope } from '@hooks';

export interface AiFixButtonProps {
	sonarObjectId: number;
}

export const AiFixButton: React.FC<AiFixButtonProps> = ({ sonarObjectId }) => {
	const { open } = useAnalysisPeriscope();

	return (
		<FeatureBoundary feature={ FeatureFlag.AIWorkflowValidationRule }>
			<Button
				className='validation-rule-ai-fix-button'
				icon={ <SparkleIconWhite /> }
				onClick={ () => open(sonarObjectId, SonarObjectType.SalesforceValidationRule) }
				type='primary'>
				{ COPY_SPECIFIC.AI_FIX }
			</Button>
		</FeatureBoundary>
	);
};
